import axios from "axios";
import { GetAllNotificationStatusFiltersDTO, GetAllNotificationStatusDTO, NotificationStatusDTO, NotificationStatusUpdateDTO } from "./dto";
import { NotificationStatusService } from "./service";
import { keycloak } from "../../../../../lib/keycloak";

export class NotificationStatusServiceImpl implements NotificationStatusService {

    public UpdateNotificationStatus(data: NotificationStatusUpdateDTO, id: string): Promise<void> {
        return axios.put("/api/notification-status/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllNotificationStatus(filters: GetAllNotificationStatusFiltersDTO): Promise<GetAllNotificationStatusDTO> {
        return axios.get("/api/notification-status", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                notificationId: filters.notificationId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetNotificationStatusById(id: string): Promise<NotificationStatusDTO> {
        return axios.get("/api/notification-status/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}